<template>
  <button
    type="button"
    :class="['number-control', type]"
    :disabled="disabled"
    @click.prevent="$emit('click')"
  >
    {{ symbol }}
  </button>
</template>

<script>
const SYMBOLS = {
  increment: '+',
  decrement: '-',
};

export default {
  name: 'NumberControl',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => Object.keys(SYMBOLS).includes(value),
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    symbol() {
      return SYMBOLS[this.type];
    },
  },
};
</script>
